module.exports = __webpack_public_path__ + "static/img/PC-2.24e1321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-2.png
// module id = vHT6
// module chunks = 0